var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / printer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 7.63086H18V2.63086H6V7.63086H5C3.346 7.63086 2 8.97686 2 10.6309V17.6309C2 18.7339 2.897 19.6309 4 19.6309H6V22.6309H18V19.6309H20C21.103 19.6309 22 18.7339 22 17.6309V10.6309C22 8.97686 20.654 7.63086 19 7.63086ZM8 4.63086H16V7.63086H8V4.63086ZM16 20.6309H8V16.6309H16V20.6309ZM20 17.6309H18V14.6309H6V17.6309H4V10.6309C4 10.0799 4.449 9.63086 5 9.63086H19C19.552 9.63086 20 10.0799 20 10.6309V17.6309Z",
    fill: "#1B1A1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.6309H18V12.6309H14V10.6309Z",
    fill: "#1B1A1B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterIcon);
export default __webpack_public_path__ + "static/media/printer-icon.616a24f27e88365f26089af856ccb3d2.svg";
export { ForwardRef as ReactComponent };